import React from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
// components
import TimeBasedLinks from "../components/TimeBasedLinks";
import withUrlSortParam from "../components/withUrlSortParam";
// helpers + selectors
import { TIME_FILTERS } from "../helpers/constants";
const mapStateToProps = (state, ownProps) => {
    const { hrefGenerator, requireUnfiltered = true, showFilter = fromJS(TIME_FILTERS) } = ownProps;
    let links = showFilter.map(showFilterMap => ({
        title: showFilterMap.get("display"),
        href: hrefGenerator(showFilterMap.get("key"))
    }));
    if (requireUnfiltered) {
        const unfiltered = {
            title: "All",
            href: hrefGenerator()
        };
        links = links.unshift(unfiltered);
    }
    return {
        links,
        showFilter
    };
};
export default withUrlSortParam(connect(mapStateToProps)(TimeBasedLinks));
